import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function MinionIdField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (newValue === '') {
      setError('Minion ID cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Minion ID'
          id='minion_id'
          aria-describedby='minion-id-helper-text'
          variant='outlined'
          onChange={handleChange}
          value={value}
          disabled={edit}
        />{' '}
        {error ? (
          <FormHelperText id='name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='name-helper-text'>
            Enter the CloudBender minion_id displayed on the node's console.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
